<template>
    <v-row justify="center" align="center" no-gutters>
        <v-col cols="12" xl="12" lg="12" md="10" sm="10">

            <v-row justify="center" no-gutters>
                <span class="text-h6 text-sm-h5 text-center">Record Your Voice</span>
            </v-row>

            <!-- DUAL DEVICE CREATION ***REMOVED ON OCTOBER 28, 2022 AT MARTY'S REQUEST (last seen in code on January 2, 2024 in vue3 git branch)***  -->

            <v-row justify="center" no-gutters class="mt-4">
                <v-col cols="12" xl="8" lg="8" md="12" sm="12" xs="12" class="pr-lg-5">
                    <v-row id="textCardContainer" justify="center" class="ma-0 pa-0">
                        <!-- <TextCreationIndexCardContainer
                            :textPost="propPostData"
                            :textCardIndexAssociationValue="textCardIndexAssociationValue"
                            :triggerAnimationAfterRecord="triggerAnimationAfterRecord"
                            @textIndexChevronPressed="changeTextCardIndexAssociationValue"
                        /> -->
                        <v-col cols="12" xl="9" lg="10" md="12" sm="12" xs="12" class="px-xl-10 px-lg-5 px-md-2">
                            <TextContributionIndexCardContainer
                                ref="textContributionIndexCardContainer"
                                :textPost="propPostData"
                                :currentAudioElementAudioData="currentAudioElement || null"
                                :audioIsLoading="textCardAudioIsLoading"
                                :audioIsPlaying="textCardAudioIsPlaying"
                                :selectedAudioId="selectedAudioId"
                                :triggerAnimationAfterRecord="triggerAnimationAfterRecord"
                                :changeAudioElementClicked="changeAudioElementClicked"
                                :changeAudioSegmentClicked="changeAudioSegmentClicked"
                                @playOrPauseAudioClicked="playOrPauseAudio"
                                @loadAndPreloadAudioData="loadAndPreloadAudioData"
                                @textIndexChevronPressed="changeTextCardIndexAssociationValue"
                                @resetChangeAudioElementClicked="changeAudioElementClicked = false"
                                @resetChangeAudioSegmentClicked="changeAudioSegmentClicked = null"
                            />
                        </v-col>
                        <!-- textCardAudioIsLoading || false
                        textCardAudioIsPlaying || false
                        @captionVolumeChanged="adjustCaptionVolume"
                        @playbackRateChanged="adjustPlaybackRate"; -->

                        <v-row id="durationBarContainer" justify="center" class="ma-0 pa-0">
                            <v-col cols="12" xl="10" lg="10" md="12" sm="12" class="ma-0 pa-0">
                                <v-row v-if="$vuetify.breakpoint.mdAndDown" justify="end" align="center" class="full-width ma-0 pa-0">
                                    <!-- <RecordProgressBar :emitTime="emitTime" :timePlaying="timePlaying" :showProgressBar="showProgressBar" class="mt-n4 mb-2"/> -->
                                     <TextRecordProgressBar :emitTime="emitTime" :timePlaying="timePlaying" :showProgressBar="showProgressBar" class="mt-0 mb-2"/>
                                    <v-btn v-if="!audioLoading && !isRecording" depressed fab small raised style="z-index: 2; transform: translateY(50%);" class="primary hidden-lg-and-up mr-2" @click.stop="showContributionDialogForMobile = true">
                                        <v-icon large justify="center" align="center">mdi-waveform</v-icon>
                                    </v-btn>
                                    <Push :isDraftPost="isDraftPost" :tawqin="tawqin" :showProgressBar="showProgressBar" :editState="editState" :isTextPostCreation="true" @controlRecordState="controlRecordState" @emitAudioSeg="updateTawqDataAfterUploadAudioRec"/>
                                    <!-- <Push v-if="userData.pushToTawq" :isDraftPost="isDraftPost" :tawqin="tawqin" :showProgressBar="showProgressBar" :editState="editState" @controlVideoState="controlVideoState" @emitAudioSeg="updateTawqDataAfterUploadAudioRec"/>
                                    <Pickup v-else :isDraftPost="isDraftPost" :tawqin="tawqin" @controlVideoState="controlVideoState" @emitAudioSeg="updateTawqDataAfterUploadAudioRec"/> -->
                                    <v-dialog v-if="!audioLoading && !isRecording" v-model="showContributionDialogForMobile" transition="dialog-bottom-transition" fullscreen scrollable overlay-opacity="0.9" class="hidden-md-and-up">
                                        <!-- <template v-slot:activator="{ on }">
                                            <Push v-if="userData.pushToTawq" :isDraftPost="isDraftPost" :tawqin="tawqin" :showProgressBar="showProgressBar" :editState="editState" @controlVideoState="controlVideoState" @emitAudioSeg="updateTawqDataAfterUploadAudioRec"/>
                                            <Pickup v-else :isDraftPost="isDraftPost" :tawqin="tawqin" @controlVideoState="controlVideoState" @emitAudioSeg="updateTawqDataAfterUploadAudioRec"/>
                                            <v-btn v-on="on" depressed fab small raised style="z-index: 2; transform: translateY(50%);" class="primary hidden-lg-and-up mr-2">
                                                <v-icon large justify="center" align="center">mdi-waveform</v-icon>
                                            </v-btn>
                                        </template> -->

                                        <v-card>
                                            <v-toolbar top dense class="full-width d-flex flex-row justify-start align-center primary pa-2">
                                                <!-- <v-btn icon small @click="showContributionDialogForMobile = false"> -->
                                                <v-btn icon small @click="closeMobileContributionCollection">
                                                    <v-icon color="icon--text">mdi-close</v-icon>
                                                </v-btn>
                                                <v-toolbar-title>Contributions</v-toolbar-title>
                                            </v-toolbar>
                                            <TextContributionCollection
                                                v-if="showContributionDialogForMobile && showContributions"
                                                :audioData="audioData"
                                                :filter="filter"
                                                :selectedAudioId="selectedAudioId"
                                                :audioLoading="audioLoading"
                                                :audioElementHasBegunPlaying="audioElementHasBegunPlaying"
                                                :isCreating="true"
                                                @audioChanged="changeAudioElement"
                                                @changeAudioSegment="changeAudioSegment"
                                            />
                                        </v-card>
                                    </v-dialog>
                                </v-row>

                                <v-row v-else justify="space-between" align="center">
                                    <TextRecordProgressBar :emitTime="emitTime" :timePlaying="timePlaying" :showProgressBar="showProgressBar"/>
                                    <!-- <Push :isDraftPost="isDraftPost" :tawqin="tawqin" :showProgressBar="showProgressBar" :editState="editState" @controlVideoState="controlVideoState" @emitAudioSeg="updateTawqDataAfterUploadAudioRec"/> -->
                                    <Push :isDraftPost="isDraftPost" :tawqin="tawqin" :showProgressBar="showProgressBar" :editState="editState" :isTextPostCreation="true" @controlRecordState="controlRecordState" @emitAudioSeg="updateTawqDataAfterUploadAudioRec"/>
                                </v-row>
                            </v-col>

                            <v-col cols="12" xl="10" lg="10" md="12" sm="12" class="caption-card-container d-flex flex-column-reverse inverseGrey py-6">
                                <TextContributionCaptionCard
                                    v-for="(data, key) in tawqData"
                                    :key="parseInt(key)"
                                    :index="parseInt(key)"
                                    :showCaptions="(newAudioData.languageSelected.text === 'None (Disable Auto Captions)' ? false : true)"
                                    :loading="data.caption === null || data.audio === null"
                                    :videoDuration="videoDuration"
                                    @deleteAudioSegment="deleteAudioSegment"
                                    @audioPlay="playAudioSegment"
                                    @updateScroll="updateScroll"
                                    @editState="sendEditStateToPush"
                                />
                                <v-divider v-if="hasAudio"/>
                                <!-- <div v-if="!showCaptions" class="text-lg-subtitle-2 text-caption text-center">Automatic captioning has been disabled. To enable, go to back to step 1 and select the language you will be speaking. You must record at least once to move to the review process.</div> -->
                                <div :class="(newAudioData.languageSelected.text === 'None (Disable Auto Captions)' ? 'mb-2' : !isMobile ? 'mt-8' : '')" class="text-lg-subtitle-2 text-caption text-center">{{((newAudioData.languageSelected.text === 'None (Disable Auto Captions)' && !showCaptions) ? 'Automatic captioning has been disabled. To enable, go back to step 1 and select the language you will be speaking. You must record at least once to move to save.' : (newAudioData.languageSelected.text === 'None (Disable Auto Captions)' && showCaptions) ? 'Automatic captioning has been disabled. To enable, delete your current segments and go to back to step 1 and select the language you will be speaking.' : (!showCaptions ? 'You must record at least once to move to save.' : ''))}}</div>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-col>
                <v-col id="contributionCollectionContainer" cols="12" xl="3" lg="4" md="12" sm="12" style="overflow-y: scroll;" class="hidden-md-and-down">
                    <TextContributionCollection
                        :audioData="audioData"
                        :filter="filter"
                        :selectedAudioId="selectedAudioId"
                        :audioLoading="audioLoading"
                        :audioElementHasBegunPlaying="audioElementHasBegunPlaying"
                        :isCreating="true"
                        @audioChanged="changeAudioElement"
                        @changeAudioSegment="changeAudioSegment"
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import firebase from "../../../../firebaseConfig";
import TextContributionIndexCardContainer from "./TextContributionIndexCardContainer.vue";
import TextContributionCaptionCard from "./TextContributionCaptionCard.vue";
import TextContributionCollection from "./TextContributionCollection.vue";
import Push from "../../Mobile/Push";
import Pickup from "../../Mobile/Pickup";
import TextRecordProgressBar from "../../TextPost/TextRecordProgressBar.vue";

export default {
    name: "text-contribution-creation",
    props: ["propPostData", "propAudioData", /*"matchAudioStartTimesWithSelectedContribution"*/],
    components: {
        TextContributionIndexCardContainer,
        TextContributionCaptionCard,
        TextContributionCollection,
        Push,
        Pickup,
        TextRecordProgressBar,
    },
    data: function () {
        return {
            isDraftPost: false, // in contribution this will always be false. We send value to push/pickup, so we need to set it to false here.
            currentMobile: {
                state: "@pause",
                prevState: "@play",
            },
            segStart: "",
            textSeg: {
                segment: 0,
                vStart: null,
            },
            vIgnore: 0.5,
            tawqin: {},
            dbRefs: {
                subtitleRef: null,
                conversionRef: null,
            },

            textCardIndexAssociationValue: 0,

            emitTime: 0,
            timePlaying: 60000,
            INTERVAL: 1000,
            captionTimer: null,
            showProgressBar: false, // not really necessary right here but is in legacy code
            editState: false,
            showCaptions: false,
            showContributions: false,
            showContributionDialogForMobile: false, // this is for mobile screens, and will show the dialog so that the user can select contributions
            showSelectedContributionTimeout: null,
            mobileAudioElementSelected: null, // true if play button on audioElement selected, false if play button on audioSegment selected.
            changeValueForDatabaseCapture: 0,
            isRecording: false,
            isPlayingOwnCreatedSegment: false,

            /* new data for seeing contributions while creating is below */
            audioLoading: true,
            audioData: [], // this is used for saved contributions, not the new contributions!
            selectedAudioId: null,
            currentAudioElement: null, // this will be the currently selected AudioElement.
            currentAudioSegment: null, // this will be the current segment loaded into the audioPlayer.
            previousAudioSegment: null,
            nextAudioSegment: null, // this will be the next audio segment to be loaded into the audioPlayer.
            audioElementOrSegmentClicked: false,
            audioCanPlay: false, // Used to make sure audio is ready to play when marker is reached.

            textCardAudioIsLoading: false,
            textCardAudioIsPlaying: false,

            previousAudioPlayer: null,
            audioPlayer: new Audio(),
            nextAudioPlayer: new Audio(),
            createdCaptionAudioPlayer: new Audio(),

            audioElementHasBegunPlaying: false,
            filter: {
                languageSelected: "All",
                languageCodes: ["All"],
            },

            triggerAnimationAfterRecord: false,
            changeAudioElementClicked: false,
            changeAudioSegmentClicked: null,

        };
    },
    methods: {
        turnOnRefs: function (userId) {
            this.dbRefs.subtitleRef = firebase.rtDb.ref(`${userId}/${this.newAudioData.audioDataId}/subtitle`);
            this.dbRefs.conversionRef = firebase.rtDb.ref(`${userId}/${this.newAudioData.audioDataId}/conversion`);
        },
        turnOffRefs: function() {
            this.dbRefs.subtitleRef.off();
            this.dbRefs.conversionRef.off();
        },
        changeTextCardIndexAssociationValue: function (value) {
            // console.log("changeTextCardIndexAssociationValue: ", value);
            if (value == 'next' /*&& ((this.textCardIndexAssociationValue + 1) <= (this.textPost.textAdded.length - 1))*/) {
                if (this.triggerAnimationAfterRecord) this.triggerAnimationAfterRecord = false;
                this.textCardIndexAssociationValue += 1;
            } else if (value == 'previous' /*&& ((this.textCardIndexAssociationValue - 1) >= 0)*/) {
                this.textCardIndexAssociationValue -= 1;
            }
            // console.log("textCardIndexAssociationValue: ", this.textCardIndexAssociationValue);
        },
        closeMobileContributionCollection: function () {
            if (this.showSelectedContributionTimeout) {
                clearTimeout(this.showSelectedContributionTimeout);
                this.showSelectedContributionTimeout = null;
                this.mobileAudioElementSelected.isAudioElement ? this.loadAndPreloadFirstAudioData() : this.loadAndPreloadAudioDataAfterClick(this.mobileAudioElementSelected.segmentToPlay);
            }
            this.showContributionDialogForMobile = false
        },
        controlRecordState: function (currState, prevState) {
            // console.log("controlRecordState: ", currState, prevState);

            !this.audioPlayer.paused && this.audioPlayer.pause();

            if (currState === "@record") {
                this.contentCreationStep.complete = false;
                this.isRecording = true;


                this.segStart = Date.now();
                this.textSeg.vStart = 0; // vidPlayer.playerGetTime();
                this.emitTime = 0;

                this.captionTimer = setInterval(() => {
                    this.emitTime += this.INTERVAL;
                }, this.INTERVAL);
            }

            if (prevState === "@record") { // reset progress bar timer
                this.isRecording = false;
                clearInterval(this.captionTimer);
                // this.timePlaying = 0;
                this.emitTime = 0;

                const segEnd = Date.now();
                var dt = (Math.abs(segEnd - this.segStart) / 1000) % 60; // get seconds from vid segment difference
                // console.log("dt: ", dt);
                if (dt > this.vIgnore) {
                    // console.log("this.tawqData: ", this.tawqData);
                    // console.log("this.textSeg.segment: ", this.textSeg.segment);
                    this.textSeg.segment = this.findLargestSegId + 1;
                    this.textSeg.dt = dt;
                    this.textSeg.textCardIndexAssociationValue = this.textCardIndexAssociationValue + 1;
                    var textSegValue = JSON.parse(JSON.stringify(this.textSeg));
                    // console.log("textSegValue: ",textSegValue);
                    this.$set(this.tawqData, this.textSeg.segment, {
                        'textSeg': textSegValue,
                        'audio': (typeof this.tawqData[this.textSeg.segment] != 'undefined') ? this.tawqData[this.textSeg.segment].audio : null,
                        'caption': (typeof this.tawqData[this.textSeg.segment] != 'undefined') ? this.tawqData[this.textSeg.segment].caption : null,
                    });
                    this.textSeg.vStart = null;
                    // this.changeTextCardIndexAssociationValue("next");
                    this.triggerAnimationAfterRecord = true;
                } else { // This case only happens when a recording is not long enough, that is to say, less than half a second. So this should only be called when the record/stop button(s) are pressed in rapid succession. When this happens the 'Next' button become disabled and will not reenable unless the below function is called
                    this.checkForErrorInTawqData(this.tawqData);
                }
            }
        },
        updateTawqDataAfterUploadAudioRec: function (audioSeg) {
            // console.log("updateTawqDataAfterUploadAudioRec: ", audioSeg);
            if (audioSeg.error) { // occurs in Push.vue or Pickup.vue, when audio file fails to upload to firebase cloud storage
                // console.log("audioSeg.error: ", audioSeg.error);
                this.tawqData[audioSeg.segment].error = audioSeg.error;
                this.tawqData[audioSeg.segment].audio = audioSeg;
                this.tawqData[audioSeg.segment].caption = "*This Audio Segment Failed. Delete it to Continue*";
                this.contentCreationStep.complete = false;
            } else {
                // console.log("No error after uploading!");
                let timeout = 570000; // 9.5 minutes, just to make sure the cloud function times out.
                const timeoutId = setTimeout(() => { // because there is a timeout of 9 minutes for the cloud function, and there is no error sent if the cloud function times out, we will set a timeout function here (since this is the first place we know the audio file has been uploaded).
                    this.$emit("clearCloudFunctionTimeout", audioSeg.segment, false); // timeout function completed, which means the cloud function reached timeout limit of 9 minutes. only clear timeoutId from parent (NewPost.vue) components cloudFunctionTimeoutIds
                }, timeout);
                this.$emit("setCloudFunctionTimeout", audioSeg.segment, timeoutId);

                if (typeof this.tawqData[audioSeg.segment] === "undefined") { // we can't create a new audio object here because we won't have the video seg data for it...return;
                    // console.log("tawqData is undefined");
                    return;
                } else if (typeof this.tawqData[audioSeg.segment].audio === 'undefined' || this.tawqData[audioSeg.segment].audio === null) { // saving the audio object for the first time
                    let startTime = this.tawqData[audioSeg.segment].textSeg.vStart // time of video when record is pressed
                    // let startTime = Math.max(0, this.tawqData[audioSeg.segment].textSeg.vStart - this.tawqData[audioSeg.segment].textSeg.dt); // time of video when record is pressed minus length of recording
                    // if (this.currentAudioElement !== null && this.previousAudioSegment !== null) {
                    //     let withinSpecifiedTime = (Math.abs((this.currentAudioElement.audioData.audio[this.previousAudioSegment.segment - 1].audioStart + this.currentAudioElement.audioData.audio[this.previousAudioSegment.segment - 1].audioDur) - this.tawqData[audioSeg.segment].textSeg.vStart) <= 1.0);
                    //     let isGreaterThanCurrentSegment = (this.tawqData[audioSeg.segment].textSeg.vStart >= this.currentAudioElement.audioData.audio[this.previousAudioSegment.segment - 1].audioStart);
                    //     startTime = (this.matchAudioStartTimesWithSelectedContribution && isGreaterThanCurrentSegment && withinSpecifiedTime) ? this.previousAudioSegment.audioStart : startTime; // this.currentAudioElement.audioData.audio[this.previousAudioSegment.segment - 1].audioStart;
                    // }

                    audioSeg.audioStart = startTime;
                    audioSeg.audioDur = this.tawqData[audioSeg.segment].textSeg.dt;
                    audioSeg.audioEnd = audioSeg.audioStart + audioSeg.audioDur;

                    this.tawqData[audioSeg.segment].audio = audioSeg;
                    // console.log("this.tawqData: ", this.tawqData);
                } else { // we already have an audio object for this audio seg id (happens if they go back and forth between steps after already creating captions)
                    // console.log("already have audio object");
                    return;
                }
            }
        },
        pushTawqinData: function () {
            this.changeValueForDatabaseCapture++ // if we do not update this value when tawqinRef.set() is called below it will not recognize an update and there is a potential we will enter an error state that the user cannot get out of.
            var startSegId = this.findLargestSegId;
            var data = {
                languageSelected : this.newAudioData.languageSelected,
                postId : this.newAudioData.postId,
                audioDataId : this.newAudioData.audioDataId,
                startSegId: startSegId,
                changeValueForDatabaseCapture: this.changeValueForDatabaseCapture,
            };
            this.tawqin = data;
            // console.log("this.tawqin: ", this.tawqin);
        },
        checkForErrorInTawqData: function (data) { // This function is used to make sure there is not an error in any of the completed AudioSegments. If there is we don't allow the user to move on in the creation process.
            if (this.isRecording && !this.contentCreationStep.complete) return;
            this.contentCreationStep.complete = !Object.values(data).some(item => (item.error || (item.caption === null)));
        },
        setAudioSegmentURL: function (filename, location) {
            // console.log("Setting audio segment url for filename: ", filename, " at location: ", location);
            let storageRef = firebase.storage.ref();
            storageRef.child(`${location}`).getDownloadURL().then((url) => {
                this.tawqData[parseInt(filename)].audio.audioURL = url;
                this.checkForErrorInTawqData(this.tawqData);
                this.$emit("clearCloudFunctionTimeout", parseInt(filename), true); // cloud function completed, clear timeout function and timeoutId from parent (NewPost.vue) components cloudFunctionTimeoutIds
            }).catch((error) => {
                // console.log("An error occured when setting the audio segment url. The error is: ", error);
                console.log("An error occured when setting the audio segment url. The error is: ", error);
                this.$store.commit('alertUser', { show: true, text: `Oops, Couldn't retrieve your audio segments at this time`, type: 'snackbar' });
            });
        },
        playAudioSegment: function(audioSegId) {
            !this.audioPlayer.paused && this.audioPlayer.pause(); // if the player is NOT paused then pause, else nothing;
            this.removeAudioPlayerEventListeners();

            this.isPlayingOwnCreatedSegment = true;
            // this.creationMode = true;

            let audioToPlay = this.tawqData[audioSegId].audio;
            this.createdCaptionAudioPlayer.src = audioToPlay.audioURL;
            this.createdCaptionAudioPlayer.play();

            this.createdCaptionAudioPlayer.addEventListener("ended", () => {
                this.isPlayingOwnCreatedSegment = false;
                this.createdCaptionAudioPlayer = new Audio();
            }, { once: true });
        },
        deleteAudioSegment: function(data) { // this function deletes the segment from the firestore database
            if (data.audioSegmentFailed) { this.deleteAudioSegmentLocally(data); return; } // segment failed to upload, only delete locally

            var storageRef = firebase.storage.ref("audioSegments");
            var audioRef = storageRef.child(`/${this.propPostData.postId}/${this.newAudioData.audioDataId}/${data.audioSegId}`);

            audioRef.delete().then(() => {
                    this.deleteAudioSegmentLocally(data); // go delete the local list of audioData
            }).catch((error) => {
                console.log("error deleting audio file: ", error.message);
                this.$store.commit('alertUser', { show: true, text: `Couldn't delete the audio file. Error: ${error.message}`, type: 'snackbar' });
            });
        },
        deleteAudioSegmentLocally: function (data) {
            // this.creationMode = true;
            this.$delete(this.tawqData, data.audioSegId);
            this.pushTawqinData();
            this.checkForErrorInTawqData(this.tawqData);
            if (!this.hasAudio) this.contentCreationStep.complete = false;
        },
        updateScroll: function() {
            var element = document.getElementsByClassName("caption-card-container")[0];
            let height = element.scrollHeight;
            element.scrollTop = ( 0 - height );
        },
        sendEditStateToPush: function (editState) {
            this.editState = editState;
        },
        getAudioData: async function () {
            /* This function will retrieve the metadata for the audio segments, not the audio itself.
            We will query the owners audio segments first, adding them to our local array. after we will
            query every audio segment, and only add it to the array if it hasn't been added yet. Firebase Querying
            does not allow '!= ', or for us to use where clause with orderby clause on different fields. */
            this.audioLoading = true;

            let permissions = await this.setAudioPermissions(); 
            if (permissions === 0) return;

            this.audioData = [];
            let audioRef = firebase.db.collection("audioSegments").where("postId", "==", this.currentPost.postId).orderBy("date", "desc");

            try {
                const snapshot = await audioRef.get();

                if (snapshot.empty) { this.audioLoading = false; return; }

                snapshot.forEach((doc) => {
                    let data = {
                        audioData: doc.data(),
                        audioDataId: doc.id,
                    };

                    if (data.audioData.audio.length > 0) {
                        if (data.audioDataId == this.currentPost.postAudioDataId) { // it is the main audioData that is associated with the post, add it to the front
                            this.audioData.unshift(data);
                        } else { // not main audio, add to back of list
                            if (permissions === 1 || (permissions === 2 && doc.data().userId === firebase.auth.currentUser.uid)) {
                                this.audioData.push(data);
                            }
                        }
                    }

                    if (typeof data.audioData.languageName !== 'undefined' && !this.filter.languageCodes.includes(data.audioData.languageName)) {
                        this.filter.languageCodes.push(data.audioData.languageName);
                    }
                });

                this.audioLoading = false;
                this.showContributions = true;
            } catch (error) {
                console.error(error);
                this.$store.commit('alertUser', { show: true, text: `Something went wrong: ${error.message}`, type: 'snackbar' });
            }
        },
        setAudioPermissions: async function () { // permisions: 0 = none, 1 = all,  2 = only current users and main one
            if (this.currentPost.postType !== 'group') return 1; // public post, allow to see all

            const gId = this.currentPost.groupId;
            const index = this.userGroups.findIndex((group) => group.groupId === gId);

            if (index === -1) { // gId does not exist in userGroups
                if (this.userData.admin) return 1; // user is admin, allow to see all

                this.letUserSeePost = false; // it is a group video, and they aren't part of that group....
                return 0;
            }

            let isAdmin = this.userGroups[index].admin;
            if (isAdmin || this.userData.admin) return 1; // user is admin or group admin, allow to see all

            if (this.userGroups[index].privateContributions) return 2; // group post has privateContributions set, only show the main/original audio and any audio created by the current user

            return 1;
        },
        setContributionCollectionContainerHeight(){
            // console.log("vuetify breakpoint: ", this.$vuetify.breakpoint.mdAndDown);
            // // console.log("setContributionCollectionContainerHeight called");
            // // this is used to set the height on the contributionCollectionContainer height for large and x-large screens (when it isn't in the dialog)
            // const h1 = document.getElementById('textCardContainer').offsetHeight;
            // const h2 = document.getElementById('durationBarContainer').offsetHeight;
            // const container = document.getElementById('contributionCollectionContainer');
            // container.style.maxHeight = `${Math.abs(h1 + h2 + 20)}px`;
            // container.style.maxHeight = `${Math.abs(h1)}px`;
        },


        //// CONTRIBUTION PLAYING FUNCTIONALITY ////


        loadAndPreloadFirstAudioData: async function () {
            this.textCardAudioIsLoading = true;

            this.currentAudioSegment = this.currentAudioElement.audioData.text[0]; // load first AudioElements text data into this.currentAudioSegment
            this.currentAudioSegment.index = 0;
            this.currentAudioSegment.hasBeenPlayed = false; // set this to false so it will show a play button for the currently selected text card
            this.addAudioPlayerEventListeners(); // Add event listeners to this.audioPlayer here so that we don't miss any events the browser might fire when setting this.audioPlayer below

            this.audioPlayer.preload = 'auto'; // preload the main (current) audioPlayer so we don't miss any events (browser can fetch aggressively)
            this.audioPlayer.src = this.currentAudioSegment.audioURL; // set the first AudioSegment audio URL into this.audioPlayer src
            this.audioPlayer.load(); // load the audio data so we can play the audio file

            if (this.currentAudioElement.audioData.text.length > 1) { // preloadNextAudioSegment, if available, so it is ready for play when it's text card is selected
                this.nextAudioSegment = this.currentAudioElement.audioData.text[1];
                this.nextAudioSegment.index = 1;
                this.nextAudioSegment.hasBeenPlayed = false;

                this.nextAudioPlayer.src = this.nextAudioSegment.audioURL;
                this.nextAudioPlayer.load();
            } else { // only one AudioSegment to play. No need for nextAudioPlayer. Destroying nextAudioPlayer.
                this.nextAudioSegment = null;
                this.nextAudioPlayer = this.nextAudioSegment;
            }
        },
        loadAndPreloadNextAudioData: async function (currentTextAudioSegment) {
            if (!currentTextAudioSegment || currentTextAudioSegment.segment == this.currentAudioSegment.segment) return;

            this.previousAudioSegment = this.currentAudioSegment;
            this.currentAudioSegment = this.nextAudioSegment;

            this.previousAudioPlayer = this.audioPlayer; // set this.previousAudioPlayer = this.audioPlayer, so it will stay loaded and be ready to go when needed.
            this.audioPlayer = this.nextAudioPlayer; // set this.audioPlayer = this.nextAudioPlayer, since it is already loaded it should be ready to go when set.
            this.nextAudioPlayer = null;
            this.addAudioPlayerEventListeners();

            var nextAvailableIndex;
            if (this.nextAudioSegment != null && ((this.currentAudioElement.audioData.text.length-1) >= (this.nextAudioSegment.index+1))) {
                // preload next available AudioSegment so it is ready for play when it's reached.
                nextAvailableIndex = this.nextAudioSegment.index+1; // Check to see if index+1 is out of range, if so set this.nextAudioSegment to null
                this.nextAudioSegment = this.currentAudioElement.audioData.text[nextAvailableIndex];
                this.nextAudioSegment.subtitleSegment = this.currentAudioElement.audioData.text[nextAvailableIndex].segment;
                this.nextAudioSegment.index = nextAvailableIndex;

                this.nextAudioPlayer = new Audio();
                this.nextAudioPlayer.preload = 'auto';
                this.nextAudioPlayer.src = this.nextAudioSegment.audioURL;
                this.nextAudioPlayer.load();
            } else { // only one AudioSegment to play. No need for nextAudioPlayer. Destroying nextAudioPlayer.
                this.nextAudioSegment = null;
            }
        },
        loadAndPreloadPreviousAudioData: async function (index) {
            this.nextAudioSegment = this.currentAudioSegment;
            this.currentAudioSegment = this.previousAudioSegment;

            this.nextAudioPlayer = this.audioPlayer;
            this.nextAudioPlayer.load();

            this.audioPlayer.preload = "auto";
            this.audioPlayer = this.previousAudioPlayer;
            this.audioPlayer.load();
            this.addAudioPlayerEventListeners();

            this.previousAudioPlayer = null;

            if (index > 0 && (this.currentAudioElement.audioData.text[index - 1] != undefined)) {
                this.previousAudioSegment = this.currentAudioElement.audioData.text[index - 1];
                this.previousAudioSegment.index = index - 1;

                this.previousAudioPlayer = new Audio();
                this.previousAudioPlayer.src = this.previousAudioSegment.audioURL;
                this.previousAudioPlayer.load();
            } else {
                this.previousAudioSegment = null;
            }
        },
        loadAndPreloadAudioDataAfterClick: async function (index) {
            if (index == null) return;

            this.textCardAudioIsLoading = true;

            this.previousAudioPlayer = null;
            this.audioPlayer = null;
            this.nextAudioPlayer = null;

            if (index > 0 && (this.currentAudioElement.audioData.text[index - 1] != undefined)) {
                this.previousAudioSegment = this.currentAudioElement.audioData.text[index - 1];
                this.previousAudioSegment.index = index - 1;

                this.previousAudioPlayer = new Audio();
                this.previousAudioPlayer.preload = 'auto';
                this.previousAudioPlayer.src = this.previousAudioSegment.audioURL;
                this.previousAudioPlayer.load();
            } else {
                this.previousAudioSegment = null;
            }

            this.currentAudioSegment = this.currentAudioElement.audioData.text[index];
            this.currentAudioSegment.index = index;

            this.audioPlayer = new Audio();
            this.audioPlayer.preload = 'auto';
            this.audioPlayer.src = this.currentAudioSegment.audioURL;
            this.audioPlayer.load();
            this.addAudioPlayerEventListeners();

            if ((this.currentAudioElement.audioData.text.length-1) >= (index+1)) {
                // preload next available AudioSegment so it is ready for play when it's reached.
                this.nextAudioSegment = this.currentAudioElement.audioData.text[(index+1)];
                this.nextAudioSegment.index = (index+1);

                this.nextAudioPlayer = new Audio();
                this.nextAudioPlayer.preload = 'auto';
                this.nextAudioPlayer.src = (this.nextAudioSegment && this.nextAudioSegment.audioURL);
                this.nextAudioPlayer.load();
            } else { // only one AudioSegment to play. No need for nextAudioPlayer. Destroying nextAudioPlayer.
                this.nextAudioSegment = null;
            }
        },
        loadAndPreloadAudioData: function (loadAndPreloadValue, currentTextAudioSegment, textCardIndexValue) {// 0 = previous, 1 = next, 2 = after click
            // console.log("textCardIndexValue: ", textCardIndexValue);
            if (loadAndPreloadValue == 0) { // Previous -- user went backwards by clicking left of card or left arrow chevron
                if (currentTextAudioSegment && this.previousAudioSegment && (currentTextAudioSegment.index == this.previousAudioSegment.index)) {
                    this.loadAndPreloadPreviousAudioData(currentTextAudioSegment.index);
                } else { // user went backwards by double clicking left arrow chevron, or by using the text card menu and skipping more than one card
                    this.loadAndPreloadAudioDataAfterClick((currentTextAudioSegment ? (currentTextAudioSegment.index != undefined ? currentTextAudioSegment.index : (currentTextAudioSegment.segment-1)) : null));
                }
            } else if (loadAndPreloadValue == 1) { // Next -- user went forwards by clicking right of card or right arrow chevron, ONE CLICK ONLY!
                this.loadAndPreloadNextAudioData(currentTextAudioSegment);
            } else/* if (loadAndPreloadValue == 2)*/ { // After click -- user went forwards by double clicking right arrow chevron or by selecting a higher numbered card from the text card menu
                this.loadAndPreloadAudioDataAfterClick((currentTextAudioSegment ? (currentTextAudioSegment.index != undefined ? currentTextAudioSegment.index : textCardIndexValue) : null));
            }
        },
        addAudioPlayerEventListeners: function () {
            this.audioPlayer.addEventListener('canplaythrough', this.audioCanPlayThrough/*, {once: true}*/);
            this.audioPlayer.addEventListener("ended", this.audioEnded/*, {once: true}*/);
        },
        removeAudioPlayerEventListeners: function () {
            this.audioPlayer.removeEventListener("canplaythrough", this.audioCanPlayThrough);
            this.audioPlayer.removeEventListener("ended", this.audioEnded/*, {once: true}*/);
        },
        audioCanPlayThrough: function () {
            this.textCardAudioIsLoading = false;
        },
        audioEnded: function (/*event*/) {
            this.textCardAudioIsPlaying = false;
            this.currentAudioSegment.hasBeenPlayed = true;
            // this.$refs.textContributionIndexCardContainer?.handleAutoSkipTrigger();
        },
        changeAudioElement: function (audioData, audioId) {
            // This function is called Everytime an AudioElement is clicked.
            // Therefore we must reset the audioSegment number, or else it can/will increment higher
            // than the actual length of the audioData.

            if (this.selectedAudioId === audioId) return; // The currently selected AudioElement is clicked again, return
            if (this.isRecording) { this.$store.commit('alertUser', { show: true, text: "Cannot select a Contribution while recording.", type: 'snackbar' }); return; } // alerts user and does not allow them to select an AudioElement/Segment while recording. Mostly used for desktop size because the button to show the contributions dialog should not be visible while recording

            this.changeAudioElementClicked = true;

            !this.audioPlayer.paused && this.audioPlayer.pause();
            this.textCardAudioIsPlaying = false;
            this.removeAudioPlayerEventListeners();

            this.currentAudioElement = {
                audioDataId: audioId,
                audioData: audioData,
            };
            this.selectedAudioId = audioId;
            this.$router.replace({path: this.$route.name, query: { pid: this.propPostData.postId, postType: this.propPostData.postType, aid: this.selectedAudioId}});

            this.audioElementHasBegunPlaying = true;

            if (this.isMobile) {
                this.mobileAudioElementSelected = {
                    isAudioElement: true,
                    segmentToPlay: null,
                };
                this.showSelectedContributionTimeout = setTimeout(() => {
                    this.showContributionDialogForMobile = !this.showContributionDialogForMobile; // if a user is using a mobile device and selects an AudioElement then close the fullscreen dialog
                    this.loadAndPreloadFirstAudioData();
                }, 500);
            } else {
                this.$nextTick(() => {
                    this.loadAndPreloadAudioData(2, this.$refs.textContributionIndexCardContainer.currentSubtitle, (this.$refs.textContributionIndexCardContainer.textCardIndex));
                });
            }
        },
        changeAudioSegment: function (data) { // this function is ran only when a audioSegment is clicked. It will update the markers if necessary and playSelectedAudioSegment
            if (this.isRecording) { return this.$store.commit('alertUser', { show: true, text: "Cannot select a Contribution while recording.", type: 'snackbar' }); } // alerts user and does not allow them to select an AudioElement/Segment while recording. Mostly used for desktop size because the button to show the contributions dialog should not be visible while recording

            !this.audioPlayer.paused && this.audioPlayer.pause(); // if the player is NOT paused then pause, else nothing;
            this.textCardAudioIsPlaying = false;
            this.removeAudioPlayerEventListeners();

            if (this.selectedAudioId === data.audioId) { // If the AudioSegment clicked is the same as the current AudioElement
                if (data.audioSeg.audioSeg.textCardIndexAssociationValue === this.$refs.textContributionIndexCardContainer.currentSubtitle.textCardIndexAssociationValue) {
                    return;
                } else {
                    this.changeAudioSegmentClicked = data.audioSeg.audioSeg;
                }
            } else {
                this.currentAudioElement = {
                    audioDataId: data.audioId,
                    audioData: data.audioData,
                };
                this.selectedAudioId = data.audioId;

                data.audioSeg.audioSeg.index = data.audioSeg.index;
                data.audioSeg.audioSeg.hasBeenPlayed = false;

                this.changeAudioSegmentClicked = data.audioSeg.audioSeg;

                this.$router.replace({path: this.$route.name, query: { pid: this.propPostData.postId, postType: this.propPostData.postType, aid: this.selectedAudioId}});

                this.audioElementHasBegunPlaying = false; // Do I need this???
            }
            if (this.isMobile) {
                this.mobileAudioElementSelected = {
                    isAudioElement: false,
                    segmentToPlay: data.audioSeg.index,
                };
                this.showSelectedContributionTimeout = setTimeout(() => {
                    this.showContributionDialogForMobile = !this.showContributionDialogForMobile; // if a user is using a mobile device and selects an AudioElement then close the fullscreen dialog
                    this.loadAndPreloadAudioData(2, this.$refs.textContributionIndexCardContainer.currentSubtitle, (this.$refs.textContributionIndexCardContainer.textCardIndex));
                }, 500);
            } else {
                this.$nextTick(() => {
                    this.loadAndPreloadAudioData(2, this.$refs.textContributionIndexCardContainer.currentSubtitle, (this.$refs.textContributionIndexCardContainer.textCardIndex));
                });
            }
        },
        playOrPauseAudio: function (resetHasBeenPlayed) {
            // console.log("playOrPauseAudio called: ", "\nresetHasBeenPlayed: ", resetHasBeenPlayed);
            this.audioElementHasBegunPlaying = true; // used in the AudioElement component to show a replay button for the currentAudioElement
            this.textCardAudioIsPlaying = !this.textCardAudioIsPlaying;
            if (!this.textCardAudioIsPlaying) { // PAUSE AUDIO
                this.audioPlayer.pause();
            } else { // PLAY AUDIO
                if (resetHasBeenPlayed) this.currentAudioSegment.hasBeenPlayed = false;
                // this.audioPlayer.playbackRate = this.playbackRate;
                this.audioPlayer.play();
            }
        },


        //// END CONTRIBUTION PLAYING FUNCTIONALITY ////
    },
    computed: {
        isMobile(){
            return this.$store.state.isMobileDevice;
        },
        isIOS(){
            return this.$store.state.isIOSDevice;
        },
        currentPost(){
            return this.$store.state.currentPost;
        },
        userData(){
            return this.$store.state.userData;
        },
        userGroups(){
            return this.$store.state.userGroups;
        },
        // creationMode: {
        //     get(){
        //         return this.$store.state.newTextContributionStore.creationMode;
        //     },
        //     set(value){
        //         this.$store.commit('newTextContributionStore/setCreationMode', value);
        //     }
        // },
        contentCreationStep: {
            get(){
                return this.$store.state.newTextContributionStore.contributionCreationStep;
            },
            set(value){
                this.$store.commit('newTextContributionStore/saveContributionCreationStep', value);
            }
        },
        tawqData: {
            get(){
                let data = this.$store.state.newTextContributionStore.tawqData;
                if (Object.keys(data).length > 0) this.showCaptions = true;
                else this.showCaptions = false;
                return data;
            },
            set(value){
                this.$store.commit('newTextContributionStore/saveTawqData', value);
            }
        },
        findLargestSegId: function() {
            const tawqDataKeys = Object.keys(this.tawqData);

            if (tawqDataKeys.length <= 0) return 0;

            return tawqDataKeys.reduce((largest, key) => {
                const parsedKey = parseInt(key);
                return parsedKey > largest ? parsedKey : largest;
            }, 0);
        },
        newAudioData: {
            get(){
                return this.$store.state.newTextContributionStore.newAudioData;
            },
            set(value){
                this.$store.commit('newTextContributionStore/saveNewAudioData', value);
            }
        },
        videoDuration: {
            get() {
                return this.$store.state.newTextContributionStore.contributionCreationStep.videoDuration;
            },
            set(value){
                this.$store.commit('newTextContributionStore/saveVideoDuration', value);
            }
        },
        hasCaptions () {
            return Object.values(this.tawqData).some((item) => item.caption !== undefined && item.caption !== null);
        },
        hasAudio () {
            return Object.values(this.tawqData).some((item) => item.audio !== undefined && item.audio !== null);
        },
    },
    watch: {
        // creationMode: function (newValue) {
        //     if (newValue) {
        //         // We might be able to just remove the video controls so we dont need to remove the markers and then replace them when done recording.
        //         this.$refs.vidPlayer.removeMarkers(); // we don't want any markers during creation mode
        //     }
        // },
    },
    created: function () {
        // console.log("this.propPostData: ", this.propPostData);
        // console.log("this.propAudioData: ", this.propAudioData);
        if (this.propAudioData) {
            this.audioData = this.propAudioData;
            this.audioData.forEach((doc) => {
                if (typeof doc.audioData.languageName !== 'undefined' && !this.filter.languageCodes.includes(doc.audioData.languageName)) {
                    this.filter.languageCodes.push(doc.audioData.languageName);
                }
            });
            this.showContributions = true;
            this.audioLoading = false;
        } else {
            this.getAudioData();
        }
        this.turnOnRefs(firebase.auth.currentUser.uid); //update realtime refs with current user Id to allow connection to mobile
        this.pushTawqinData();
    },
    mounted: function () {
        // this.setContributionCollectionContainerHeight();
        // window.addEventListener('resize', this.setContributionCollectionContainerHeight);

        this.dbRefs.subtitleRef.on("child_added", (snapshot) => {
            if (snapshot.val() === null) return;

            if (typeof this.tawqData[parseInt(snapshot.val().audioSegId)] === "undefined") {
                // console.log('ERROR: NOT SAVING CAPTION OBJECT BECAUSE THIS AUDIO ID IS UNDEFINED IN TAWQ DATA. audioSegId = ', snapshot.val().audioSegId); // FIGURE OUT HOW TO HANDLE THIS ERROR STATE!!!
                this.$emit("clearCloudFunctionTimeout", parseInt(snapshot.val().idToDelete), true); // cloud function failed, clear timeout function and timeoutId from parent (NewPost.vue) component
                this.tawqData[parseInt(snapshot.val().idToDelete)].error = true;
                this.tawqData[parseInt(snapshot.val().idToDelete)].caption = "*This Audio Segment Failed. Delete it to Continue*";
                this.contentCreationStep.complete = false;
                return;
            } else if (typeof this.tawqData[parseInt(snapshot.val().audioSegId)].caption === 'undefined' || this.tawqData[parseInt(snapshot.val().audioSegId)].caption === null) { // Ran the first time we are adding a caption for the specified audioSegId.
                const formattedCaption = typeof snapshot.val().subtitle !== 'undefined' ? snapshot.val().subtitle.charAt(0).toUpperCase() + snapshot.val().subtitle.slice(1) : "";
                this.tawqData[parseInt(snapshot.val().audioSegId)].caption = formattedCaption || snapshot.val().subtitle || "";
            } else { // we already have a caption for this audio seg id (happens if they go back and forth between steps after already creating captions)
                return;
            }
        },(error) => {
            console.error(error.message);
            this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
        });

        this.dbRefs.conversionRef.on("child_added", (snapshot) => {
            if (snapshot.val() === null) return;

            if (typeof this.tawqData[parseInt(snapshot.val().filename)] === "undefined") {
                this.$emit("clearCloudFunctionTimeout", parseInt(snapshot.val().idToDelete), true); // cloud function failed, clear timeout function and timeoutId from parent (NewPost.vue) component
                this.tawqData[parseInt(snapshot.val().idToDelete)].error = true;
                this.tawqData[parseInt(snapshot.val().idToDelete)].audio.audioURL = "failed";
                this.contentCreationStep.complete = false;
                return;
            } else {
                if (typeof this.tawqData[parseInt(snapshot.val().filename)].audio.audioURL != 'undefined' && this.tawqData[parseInt(snapshot.val().filename)].audio.audioURL != null) { // we have already retrieved the url for the audio (they go back and forth)
                    console.log("already retrieved the url");
                    // FIGURE OUT HOW TO HANDLE THIS ERROR STATE!!!
                    // do we need to clear the timeout here?
                    // this.$emit("clearCloudFunctionTimeout", parseInt(snapshot.val().idToDelete), true); // cloud function failed, clear timeout function and timeoutId from parent (NewPost.vue) component
                    return;
                }
                let filename = snapshot.val().filename;
                let location = snapshot.val().location;
                // we need to retrieve the url's for the audioSegments here, because the cloud function converts them to mp4 which will change the the download URL that they originally have when uploaded to storage
                this.setAudioSegmentURL(filename, location);
            }
        },(error) => {
            console.error(error.message);
            this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
        });
    },
    beforeDestroy: function () {
        // this.creationMode = true;
        if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer.remove();
        }
        clearInterval(this.captionTimer);
        this.turnOffRefs();
        // we remove the three refs below because if not, then it does a lot of unneccessary work anytime switching between steps while creating a post,
        // and this is the only component that needs that info
        this.dbRefs.subtitleRef.remove();
        this.dbRefs.conversionRef.remove();
        // window.removeEventListener('resize', this.setContributionCollectionContainerHeight);
    },
};
</script>

<style>
.smallText {
    font-size: 10px;
}

.height--80 {
    height: 80vh !important;
    max-height: 80vh !important;
}

.caption-card-container {
    max-height: 20vh;
    overflow-y: scroll;
    overflow-x: hidden;
    border-radius: 10px;
}

.caption-card-container::-webkit-scrollbar {
    width: 7px;
    height: 100%;
}

/* Handle */
.caption-card-container::-webkit-scrollbar-thumb {
    background: #86c232 !important;
    height: 20% !important;
}

.contribution-collection-menu-container {
    z-index: 5;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60vh;
    width: 100%;
    overflow-y: scroll;
}

.dialog-slide-up-enter-active {
    animation: dialog-slide-up 0.2s ease-out;
}

.dialog-slide-up-leave-active {
    animation: dialog-slide-up 0.2s ease-out reverse;
}

@keyframes dialog-slide-up {
    from{
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
}

/* XS */
@media (max-width: 600px){
    .caption-card-container {
        max-height: 35vh;
        min-height: 15vh;
    }
}

/* SM */
@media (min-width: 601px) and (max-width: 960px){
    .caption-card-container {
        max-height: 28vh;
        min-height: 12vh;
    }
}

/* MD */
@media (min-width: 961px) and (max-width: 1264px){
    .caption-card-container {
        max-height: 40vh;
        min-height: 10vh;
    }
}

/* LG */
@media (min-width: 1265px) and (max-width: 1904px){
    .caption-card-container {
        max-height: 22vh;
    }
}

/* XL */
@media (min-width: 1905px){
    .caption-card-container {
        max-height: 23vh;
    }
}
</style>
